'use client'

import { GetUspResultQuery } from '@dustin-web/microsite-data/src/graphql/content/generated/graphql-types'
import classnames from 'classnames'
import { useState, useEffect } from 'react'
import Link from 'next/link'

type Props = {
  uspData: GetUspResultQuery['usp']
  isMobile: boolean
}

export const UspBannerClient = ({ uspData, isMobile }: Props) => {
  const [count, setCount] = useState(0)

  useEffect(() => {
    if (isMobile) {
      const interval = setInterval(() => {
        setCount(count => {
          if (count == 2) {
            return 0
          } else {
            return count + 1
          }
        })
      }, 6000)
      return () => clearInterval(interval)
    }
  }, [isMobile])

  return uspData?.usps?.map((usp, index) => (
    <div
      key={index}
      className={classnames('usp-bar-link', {
        UspFadeIn: count == index && isMobile,
      })}>
      <Link prefetch={false} href={usp?.link.url}>
        {usp?.link.text}
      </Link>
    </div>
  ))
}
